"use client";

import {
  CHAIR_MATERIALS,
  formatChairMaterialLabel,
  type ChairMaterial,
  type ChairSpecFormState,
} from "@/lib/listing/chairListingSpec";
import { cn } from "@/lib/utils";

interface ChairMaterialFieldsProps {
  value: ChairSpecFormState;
  onChange: (next: ChairSpecFormState) => void;
  className?: string;
}

export default function ChairMaterialFields({
  value,
  onChange,
  className = "",
}: ChairMaterialFieldsProps) {
  const selectMaterial = (material: ChairMaterial) => {
    onChange({ ...value, chairMaterial: material });
  };

  return (
    <div className={cn("space-y-2", className)}>
      <p className="text-sm font-medium text-foreground">
        Material <span className="text-red-500">*</span>
      </p>
      <div className="flex flex-wrap gap-2">
        {CHAIR_MATERIALS.map((material) => {
          const selected = value.chairMaterial === material;
          return (
            <button
              key={material}
              type="button"
              onClick={() => selectMaterial(material)}
              className={cn(
                "rounded-lg border px-3 py-2 text-sm font-medium transition",
                selected
                  ? "border-primary bg-primary-50 text-primary-800"
                  : "border-border bg-surface text-foreground hover:border-border-strong",
              )}
              aria-pressed={selected}
            >
              {formatChairMaterialLabel(material)}
            </button>
          );
        })}
      </div>
      <p className="text-xs text-text-light">
        Choose the main material so we can build your title.
      </p>
    </div>
  );
}
